import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.promoted = Boolean(this.element.closest('dialog'));
  }

  disconnect() {
    if (this.promoted && !this.element.isConnected && document.body) document.body.appendChild(this.element);
  }
}
